import { useState } from "react";
import { motion } from "framer-motion";
import { Play, Map } from "lucide-react";
import { Button } from "@/components/ui/button";
import { CHARACTERS, LEVELS } from "@/utils/mazeGameData";

export const MazeGameSettings = ({ onStartGame, onBack }) => {
  const [selectedChar, setSelectedChar] = useState("rabbit");

  return (
    <motion.div
      initial={{ y: 20, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      className="glass-card-strong rounded-xl p-5 sm:p-7 border border-gold/20 shadow-lg w-full max-w-2xl mx-auto"
      data-testid="maze-game-settings"
    >
      <div className="flex items-center justify-center gap-2 mb-2">
        <Map className="w-7 h-7 text-white" />
        <h2 className="font-fredoka text-xl sm:text-2xl text-white">Labirin Huruf Ajaib</h2>
      </div>
      <p className="font-fredoka text-gold-light/80 text-sm text-center mb-5">
        Jelajahi labirin, temukan jawaban yang benar!
      </p>

      {/* Character Selection */}
      <div className="mb-5">
        <label className="font-fredoka text-gold-light/80 text-sm mb-2 block">Pilih Karakter</label>
        <div className="grid grid-cols-3 gap-3">
          {CHARACTERS.map((c) => (
            <Button
              key={c.id}
              data-testid={`maze-char-${c.id}`}
              variant={selectedChar === c.id ? "default" : "outline"}
              onClick={() => setSelectedChar(c.id)}
              className={`flex flex-col items-center py-4 h-auto transition-all ${
                selectedChar === c.id
                  ? "text-brown-dark shadow-lg"
                  : "border-gold/20 text-gold hover:bg-gold/10"
              }`}
              style={selectedChar === c.id ? { background: c.color, boxShadow: `0 0 15px ${c.color}50` } : {}}
            >
              <span className="text-4xl mb-1">{c.emoji}</span>
              <span className="text-xs font-fredoka">{c.name}</span>
            </Button>
          ))}
        </div>
      </div>

      {/* Level Preview */}
      <div className="mb-5">
        <label className="font-fredoka text-gold-light/80 text-sm mb-2 block">6 Level Petualangan</label>
        <div className="grid grid-cols-3 gap-2">
          {LEVELS.map((lvl) => (
            <div key={lvl.id} className="flex items-center gap-1.5 p-2 rounded-lg border border-gold/20 glass-card">
              <span className="text-lg">{lvl.icon}</span>
              <span className="text-[10px] sm:text-xs font-fredoka text-gold-light/80 leading-tight">{lvl.name}</span>
            </div>
          ))}
        </div>
      </div>

      <Button
        onClick={() => onStartGame(selectedChar)}
        className="w-full font-fredoka font-bold uppercase tracking-wide text-brown-dark bg-gradient-to-r from-yellow-400 to-amber-500 hover:bg-gradient-to-r from-yellow-400 to-amber-500/90"
        style={{ boxShadow: '0 0 20px rgba(255,215,0,0.4)' }}
        data-testid="maze-start-btn"
      >
        <Play className="w-5 h-5 mr-2" />
        Mulai Petualangan!
      </Button>

      <Button onClick={onBack} variant="ghost" className="w-full mt-2 text-gold hover:bg-gold/10 font-fredoka text-sm">
        Kembali ke Menu Utama
      </Button>
    </motion.div>
  );
};

export default MazeGameSettings;
